// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/gradient.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accent {
  color: #c6ffad
}

/*Navbar*/
.navbar {
    position: fixed;
    top: 0;
    width: 100%;
    background: #000000;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
  }
  
  .navbar-content {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 1200px; /* Optional: Adjust the maximum width of the navbar */
  }
  
  .logo-container {
    flex-shrink: 0;
    margin-right: auto;
  }
  
  .nav-logo {
    margin-top: 10px;
    height: 25px; /* Adjust logo size */
    cursor: pointer;
  }
  
  .nav-list {
    display: flex;
    justify-content: center;
    flex-grow: 1;
    margin: 0;
    padding: 0;
    list-style-type: none;
    margin-right: 100px;
  }
  
  .nav-item {
    margin: 0 15px;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    color: #626262;
    text-align: center;
  }
  
  .nav-item.active {
    color: #C6ffad;
  }

/* General Styles */
.home-container {
  overflow-y: auto; /* Enable smooth vertical scrolling */
  font-family: 'Inter';
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
  color: #fff;
}

@media (max-width: 768px) {
  .home-container {
    background: #162c41;
  }
}

.slide {
  height: 100vh; /* Each slide still takes up the full viewport height */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
}

  .icon {
    filter: brightness(0) invert(1); /* Converts the icon to white */
    width: 50px; /* Adjust the width as needed */
    height: 50px; /* Adjust the height as needed */
    transition: filter 0.3s ease; /* Optional: Smooth transition for hover effects */
  }
  
  .icon:hover {
    filter: brightness(0.8) invert(0.9); /* Slight hover effect */
  }
  
/* Slide 1: Title Slide */
.title-slide {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  color: #fff; /* Text color */
}

/* Logo at the top */
.title-logo-container {
  margin-top: 60px;
  margin-bottom: 40px;
}

.hero-logo {
  max-width: 400px;
  height: auto;
  margin-top: 20px;
}

/* Split Content */
.split-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 60%;
  max-width: 1200px; /* Optional max width */
}

/* Left Content */
.left-content {
  flex: 1 1;
  text-align: left;
  padding: 20px;
}

.hero-text {
  font-size: 2.5rem; /* Adjust font size */
  margin-bottom: 20px;
  font-weight: bold;
}

.sub-hero-text {
  font-size: 1.2rem;
  line-height: 1.6;
  color: #ffffff; /* Lighter text color for contrast */
}

/* Right Content */
.right-content {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-image {
  max-width: 80%;
  height: auto;
  object-fit: contain; /* Maintain aspect ratio */
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-logo {
    max-width: 200px;
  }

  .split-content {
    flex-direction: column; /* Stack content vertically on smaller screens */
    width: 100%;
  }

  .left-content,
  .right-content {
    text-align: left;
    padding: 10px;
  }

  .hero-text {
    font-size: 2rem;
  }

  .sub-hero-text {
    font-size: 1rem;
  }

  .product-image {
    max-width: 100%;
  }
}

  
  /* Slide 2: About */
/* Slide 2 */
.slide-2 {
    display: flex;
    flex-direction: row; /* Align items horizontally */
    height: 100vh; /* Full viewport height */
    overflow: hidden;
  }
  
  .slide-2-left {
    flex: 1 1; /* Occupies the left half */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .product-image {
    max-width: 90%;
    max-height: 90%;
    object-fit: contain; /* Ensure the image scales well without cropping */
  }
  
  .slide-2-right {
    flex: 1 1; /* Still occupies the right half in terms of layout */
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start; /* Align content to the left */
    text-align: left; /* Left-align text */
    width: 60%; /* Stretch to 80% of the container width */
    margin-left: 20px; /* Start at the very left side of the container */
  }  
  
  .slide-2-right h2 {
    font-size: 2.5rem;
    margin-bottom: 20px;
  }
  
  .slide-2-right p {
    font-size: 1.2rem;
    line-height: 1.6;
    margin-bottom: 30px;
  }
  
  .key-benefits {
    display: flex;
    flex-direction: column;
    gap: 20px; /* Space between each benefit */
  }
  
  .benefit-item {
    display: flex;
    align-items: flex-start;
    gap: 15px; /* Space between icon and text */
  }
  
  .benefit-item .icon {
    width: 50px;
    height: 50px;
  }
  
  .benefit-item p {
    font-size: 1rem;
    margin: 0;
  }

  .slide-2-hero {
    font-size: 2.5rem;
  }
  
/* Slide 3: Key Benefits */
.slide-3 {
  height: 60vh; /* Each slide still takes up the full viewport height */
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.benefits-container {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap; /* Adjust layout on smaller screens */
  margin-top: 20px;
}

.benefit-card {
  background: #f9f9f9;
  color: #333;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 300px; /* Set a fixed width for cards */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.benefit-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}

.benefit-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 15px;
}

.benefit-card h3 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.benefit-card p {
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .benefits-container {
    flex-direction: column;
    align-items: center;
    gap: 30px;
    width: 90%;
  }

  .benefit-card {
    width: 90%; /* Make cards full width on smaller screens */
  }
}
  
/* Contact Section */
.slide-4 {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  text-align: center;
  height: 40vh; /* Full viewport height */
}

/* One Unified Contact Box */
.contact-box {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  width: 70%; /* Centralized width */
  max-width: 1200px;
  background: #ffffff; /* White background for the box */
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  gap: 20px;
  text-align: left;
  position: relative;
  margin-bottom:140px;
}

/* Left Side: Waitlist */
.left-side {
  flex: 1 1;
  padding: 20px;
}

.left-side h2 {
  margin-top: 0px;
  margin-bottom: 20px;
  font-size: 1.8rem;
  color: #333;
}

.waitlist-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.waitlist-form .email-input {
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.waitlist-form .submit-button {
  padding: 10px 20px;
  background-color: #20584F;
  color: white;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.waitlist-form .submit-button:hover {
  background-color: #2e7b6f;
}

/* Right Side: Contact Us */
.right-side {
  flex: 1 1;
  padding: 20px;
}

.right-side h2 {
  margin-top: 0px;
  margin-bottom: 20px;
  font-size: 1.8rem;
  color: #333;
}

.right-side p {
  margin: 10px 0;
  font-size: 1rem;
  color: #555;
}

.right-side a {
  color: #20584F;
  text-decoration: none;
  font-weight: bold;
  transition: color 0.3s ease;
}

.right-side a:hover {
  color: #2e7b6f;
}

/* Divider Line */
.divider {
  width: 1px;
  background: #ccc; /* Light grey line */
  margin: 0 20px;
  align-self: stretch; /* Ensures it spans the height of the box */
}

/* Responsive Design */
@media (max-width: 768px) {
  .contact-box {
    flex-direction: column;
    gap: 0;
    width: 80%;
  }

  .divider {
    display: none; /* Remove divider on smaller screens */
  }

  .left-side,
  .right-side {
    padding: 20px 0;
  }
}


  

  @media (max-width: 768px) {
    /* General Styles for Phone View */
    .home-container {
        scroll-snap-type: none;
        height: auto; /* Allow container to expand with content */
        overflow-y: auto;
    }

    .slide {
        scroll-snap-align: none; /* Remove snap alignment */
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
        padding: 20px;
        height: auto;
    }

    .navbar {
        display: none;
      }

    /* Title Slide (Company Name Only) */
    .title-slide {
      height: auto; /* Adjust dynamically based on content */
      padding: 20px;
    }

    .title-slide h1 {
        font-size: 3rem;
    }
  
    .title-left {
      width: 100%; /* Use full width for the company name */
      text-align: center; /* Center the company name */
      padding: 20px 0;
    }

    .hero-logo {
        padding-top: 25px;
    }
  
    .title-right {
      display: none; /* Hide the ocean image */
    }
  
    /* Slide 2: Product Image and Info */
    .slide-2 {
      padding: 20px 0;
    }
  
    .slide-2-left {
      width: 100%; /* Make the product image full-width */
      text-align: center;
    }
  
    .product-image {
      width: 80%; /* Scale down the product image */
      height: auto; /* Maintain aspect ratio */
      margin-bottom: 20px;
    }
  
    .slide-2-right {
      width: 90%; /* Use full width for product info */
      text-align: left; /* Center-align product info */
      padding: 20px;
      margin: 20px;
    }
  
    /* Slide 3: Use Case Cards Stacked Vertically */
    .slide-3 {
      padding: 20px 0;
    }
  
    .use-case-gallery {
      flex-direction: column; /* Stack use cases vertically */
      gap: 20px; /* Add spacing between cards */
      width: 100%;
    }
  
    .use-case {
      width: 100%; /* Adjust width for smaller screens */
      height: 160px;
      max-width: 300px; /* Limit max size */
      margin: 0 auto; /* Center each use case card */
    }
  
    .use-case-image {
      width: 100%; /* Make the image fill the card */
      height: 160px; /* Maintain consistent height for all images */
    }
  
    .use-case-label {
      font-size: 1rem; /* Adjust font size for readability */
      padding: 10px;
    }
  
    /* Slide 4: Form */
    .slide-4 {
      padding: 20px 0;
    }
  
    .contact-form {
        width: 90%; /* Restrict form to one-third of the screen width */
        max-width: 400px; /* Ensure the form doesn't get too wide on larger screens */
        background-color: rgba(219, 219, 219, 0.9); /* Semi-transparent white background */
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* Add subtle shadow for depth */
        display: flex;
        flex-direction: column;
        gap: 15px; /* Spacing between form elements */
      }
    .contact-form-container {
      width: 100%; /* Expand form to fill most of the screen */
      max-width: none; /* Remove width limit */
      padding: 20px;
    }
  
    .contact-form-container h2 {
      font-size: 1.5rem; /* Adjust font size for smaller screens */
    }
  
    .email-input,
    .message-input {
        font-size: 0.9rem; /* Slightly smaller inputs */
        width: 100%; /* Ensure inputs match the width of the form */
        box-sizing: border-box; /* Include padding and borders in width calculation */
        padding: 10px; /* Add padding for readability */
        border: 1px solid #ccc;
        border-radius: 5px;
    }
  
    .submit-button {
      font-size: 1rem; /* Maintain button size */
    }

    .scroll-indicator {
        display: none; /* Completely hide the element */
    }

  }

  .confirmation-message {
    margin-top: 10px;
    font-size: 1rem;
    color: #41ad9b;
    text-align: center;
  }
  

  .footer {
    background-color: #000;
    color: #fff;
    padding: 20px 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  
  .footer-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
    max-width: 1200px;
  }
  
  .footer-left {
    flex: 1 1;
    min-width: 250px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .footer-logo {
    max-width: 150px;
    margin-bottom: 10px;
  }
  
  .footer-center {
    flex: 1 1;
    min-width: 250px;
    text-align: center;
  }
  
  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    gap: 15px;
  }
  
  .footer-links li {
    margin: 0;
  }
  
  .footer-links a {
    text-decoration: none;
    color: #41AD9B;
    font-weight: bold;
    transition: color 0.3s;
  }
  
  .footer-links a:hover {
    color: #fff;
  }
  
  .footer-right {
    flex: 1 1;
    min-width: 250px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  
  .social-icons {
    display: flex;
    gap: 15px;
  }
  
  .social-icons a img {
    width: 24px;
    height: 24px;
    filter: invert(100%);
    transition: filter 0.3s;
  }
  
  .social-icons a img:hover {
    filter: invert(60%);
  }
  
  /* Responsive Design for Footer */
  @media (max-width: 768px) {
    .footer-container {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
  
    .footer-left,
    .footer-center,
    .footer-right {
      align-items: center;
      margin-bottom: 20px;
    }
  
    .footer-right {
      align-items: center;
    }

    
  }
  
/* Video Section Styles */
.video-section {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  background: transparent;
}

.video-container {
  width: 50%;
  max-width: 800px;
  position: relative;
  padding-bottom: 28.125%; /* Maintains 16:9 aspect ratio (50% * 9/16) */
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

/* Responsive design for video */
@media (max-width: 768px) {
  .video-container {
    width: 90%;
    padding-bottom: 50.625%; /* Maintains 16:9 aspect ratio (90% * 9/16) */
  }
}
  `, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAIA;EACE;AACF;;AAEA,SAAS;AACT;IACI,eAAe;IACf,MAAM;IACN,WAAW;IACX,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB,EAAE,qDAAqD;EAC1E;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY,EAAE,qBAAqB;IACnC,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;AAEF,mBAAmB;AACnB;EACE,gBAAgB,EAAE,qCAAqC;EACvD,oBAAoB;EACpB,iFAAwE;EACxE,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa,EAAE,uDAAuD;EACtE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;EAEE;IACE,+BAA+B,EAAE,+BAA+B;IAChE,WAAW,EAAE,+BAA+B;IAC5C,YAAY,EAAE,gCAAgC;IAC9C,4BAA4B,EAAE,kDAAkD;EAClF;;EAEA;IACE,mCAAmC,EAAE,wBAAwB;EAC/D;;AAEF,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,WAAW,EAAE,eAAe;AAC9B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,iBAAiB,EAAE,uBAAuB;AAC5C;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB,EAAE,qBAAqB;EACxC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc,EAAE,oCAAoC;AACtD;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB,EAAE,gDAAgD;IACxE,WAAW;EACb;;EAEA;;IAEE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;EAGE,mBAAmB;AACrB,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB,EAAE,6BAA6B;IAClD,aAAa,EAAE,yBAAyB;IACxC,gBAAgB;EAClB;;EAEA;IACE,SAAO,EAAE,2BAA2B;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB,EAAE,kDAAkD;EACzE;;EAEA;IACE,SAAO,EAAE,qDAAqD;IAC9D,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB,EAAE,8BAA8B;IACvD,gBAAgB,EAAE,oBAAoB;IACtC,UAAU,EAAE,0CAA0C;IACtD,iBAAiB,EAAE,iDAAiD;EACtE;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAE,+BAA+B;EAC5C;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS,EAAE,gCAAgC;EAC7C;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;AAEF,0BAA0B;AAC1B;EACE,YAAY,EAAE,uDAAuD;EACrE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,eAAe,EAAE,qCAAqC;EACtD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,YAAY,EAAE,gCAAgC;EAC9C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,UAAU,EAAE,6CAA6C;EAC3D;AACF;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,YAAY,EAAE,yBAAyB;AACzC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,UAAU,EAAE,sBAAsB;EAClC,iBAAiB;EACjB,mBAAmB,EAAE,iCAAiC;EACtD,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,gBAAgB,EAAE,oBAAoB;EACtC,cAAc;EACd,mBAAmB,EAAE,2CAA2C;AAClE;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,MAAM;IACN,UAAU;EACZ;;EAEA;IACE,aAAa,EAAE,sCAAsC;EACvD;;EAEA;;IAEE,eAAe;EACjB;AACF;;;;;EAKE;IACE,kCAAkC;IAClC;QACI,sBAAsB;QACtB,YAAY,EAAE,2CAA2C;QACzD,gBAAgB;IACpB;;IAEA;QACI,uBAAuB,EAAE,0BAA0B;QACnD,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,aAAa;MACf;;IAEF,oCAAoC;IACpC;MACE,YAAY,EAAE,wCAAwC;MACtD,aAAa;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;MACE,WAAW,EAAE,wCAAwC;MACrD,kBAAkB,EAAE,4BAA4B;MAChD,eAAe;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;MACE,aAAa,EAAE,yBAAyB;IAC1C;;IAEA,oCAAoC;IACpC;MACE,eAAe;IACjB;;IAEA;MACE,WAAW,EAAE,sCAAsC;MACnD,kBAAkB;IACpB;;IAEA;MACE,UAAU,EAAE,iCAAiC;MAC7C,YAAY,EAAE,0BAA0B;MACxC,mBAAmB;IACrB;;IAEA;MACE,UAAU,EAAE,oCAAoC;MAChD,gBAAgB,EAAE,8BAA8B;MAChD,aAAa;MACb,YAAY;IACd;;IAEA,+CAA+C;IAC/C;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB,EAAE,+BAA+B;MACvD,SAAS,EAAE,8BAA8B;MACzC,WAAW;IACb;;IAEA;MACE,WAAW,EAAE,qCAAqC;MAClD,aAAa;MACb,gBAAgB,EAAE,mBAAmB;MACrC,cAAc,EAAE,8BAA8B;IAChD;;IAEA;MACE,WAAW,EAAE,iCAAiC;MAC9C,aAAa,EAAE,8CAA8C;IAC/D;;IAEA;MACE,eAAe,EAAE,qCAAqC;MACtD,aAAa;IACf;;IAEA,kBAAkB;IAClB;MACE,eAAe;IACjB;;IAEA;QACI,UAAU,EAAE,mDAAmD;QAC/D,gBAAgB,EAAE,2DAA2D;QAC7E,0CAA0C,EAAE,sCAAsC;QAClF,aAAa;QACb,mBAAmB;QACnB,2CAA2C,EAAE,gCAAgC;QAC7E,aAAa;QACb,sBAAsB;QACtB,SAAS,EAAE,kCAAkC;MAC/C;IACF;MACE,WAAW,EAAE,2CAA2C;MACxD,eAAe,EAAE,uBAAuB;MACxC,aAAa;IACf;;IAEA;MACE,iBAAiB,EAAE,yCAAyC;IAC9D;;IAEA;;QAEI,iBAAiB,EAAE,4BAA4B;QAC/C,WAAW,EAAE,8CAA8C;QAC3D,sBAAsB,EAAE,qDAAqD;QAC7E,aAAa,EAAE,gCAAgC;QAC/C,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;MACE,eAAe,EAAE,yBAAyB;IAC5C;;IAEA;QACI,aAAa,EAAE,gCAAgC;IACnD;;EAEF;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;;EAGA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,iCAAiC;EACjC;IACE;MACE,sBAAsB;MACtB,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;;;MAGE,mBAAmB;MACnB,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;;EAGF;;AAEF,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB,EAAE,6CAA6C;AACxE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,uBAAuB,EAAE,6CAA6C;EACxE;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap\");\n\n\n.accent {\n  color: #c6ffad\n}\n\n/*Navbar*/\n.navbar {\n    position: fixed;\n    top: 0;\n    width: 100%;\n    background: #000000;\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0 20px;\n  }\n  \n  .navbar-content {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    max-width: 1200px; /* Optional: Adjust the maximum width of the navbar */\n  }\n  \n  .logo-container {\n    flex-shrink: 0;\n    margin-right: auto;\n  }\n  \n  .nav-logo {\n    margin-top: 10px;\n    height: 25px; /* Adjust logo size */\n    cursor: pointer;\n  }\n  \n  .nav-list {\n    display: flex;\n    justify-content: center;\n    flex-grow: 1;\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n    margin-right: 100px;\n  }\n  \n  .nav-item {\n    margin: 0 15px;\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: bold;\n    color: #626262;\n    text-align: center;\n  }\n  \n  .nav-item.active {\n    color: #C6ffad;\n  }\n\n/* General Styles */\n.home-container {\n  overflow-y: auto; /* Enable smooth vertical scrolling */\n  font-family: 'Inter';\n  background: url('../assets/gradient.webp') no-repeat center center fixed;\n  color: #fff;\n}\n\n@media (max-width: 768px) {\n  .home-container {\n    background: #162c41;\n  }\n}\n\n.slide {\n  height: 100vh; /* Each slide still takes up the full viewport height */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 20px;\n}\n\n  .icon {\n    filter: brightness(0) invert(1); /* Converts the icon to white */\n    width: 50px; /* Adjust the width as needed */\n    height: 50px; /* Adjust the height as needed */\n    transition: filter 0.3s ease; /* Optional: Smooth transition for hover effects */\n  }\n  \n  .icon:hover {\n    filter: brightness(0.8) invert(0.9); /* Slight hover effect */\n  }\n  \n/* Slide 1: Title Slide */\n.title-slide {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 20px;\n  color: #fff; /* Text color */\n}\n\n/* Logo at the top */\n.title-logo-container {\n  margin-top: 60px;\n  margin-bottom: 40px;\n}\n\n.hero-logo {\n  max-width: 400px;\n  height: auto;\n  margin-top: 20px;\n}\n\n/* Split Content */\n.split-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 60%;\n  max-width: 1200px; /* Optional max width */\n}\n\n/* Left Content */\n.left-content {\n  flex: 1;\n  text-align: left;\n  padding: 20px;\n}\n\n.hero-text {\n  font-size: 2.5rem; /* Adjust font size */\n  margin-bottom: 20px;\n  font-weight: bold;\n}\n\n.sub-hero-text {\n  font-size: 1.2rem;\n  line-height: 1.6;\n  color: #ffffff; /* Lighter text color for contrast */\n}\n\n/* Right Content */\n.right-content {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.product-image {\n  max-width: 80%;\n  height: auto;\n  object-fit: contain; /* Maintain aspect ratio */\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hero-logo {\n    max-width: 200px;\n  }\n\n  .split-content {\n    flex-direction: column; /* Stack content vertically on smaller screens */\n    width: 100%;\n  }\n\n  .left-content,\n  .right-content {\n    text-align: left;\n    padding: 10px;\n  }\n\n  .hero-text {\n    font-size: 2rem;\n  }\n\n  .sub-hero-text {\n    font-size: 1rem;\n  }\n\n  .product-image {\n    max-width: 100%;\n  }\n}\n\n  \n  /* Slide 2: About */\n/* Slide 2 */\n.slide-2 {\n    display: flex;\n    flex-direction: row; /* Align items horizontally */\n    height: 100vh; /* Full viewport height */\n    overflow: hidden;\n  }\n  \n  .slide-2-left {\n    flex: 1; /* Occupies the left half */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .product-image {\n    max-width: 90%;\n    max-height: 90%;\n    object-fit: contain; /* Ensure the image scales well without cropping */\n  }\n  \n  .slide-2-right {\n    flex: 1; /* Still occupies the right half in terms of layout */\n    padding: 40px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start; /* Align content to the left */\n    text-align: left; /* Left-align text */\n    width: 60%; /* Stretch to 80% of the container width */\n    margin-left: 20px; /* Start at the very left side of the container */\n  }  \n  \n  .slide-2-right h2 {\n    font-size: 2.5rem;\n    margin-bottom: 20px;\n  }\n  \n  .slide-2-right p {\n    font-size: 1.2rem;\n    line-height: 1.6;\n    margin-bottom: 30px;\n  }\n  \n  .key-benefits {\n    display: flex;\n    flex-direction: column;\n    gap: 20px; /* Space between each benefit */\n  }\n  \n  .benefit-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 15px; /* Space between icon and text */\n  }\n  \n  .benefit-item .icon {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .benefit-item p {\n    font-size: 1rem;\n    margin: 0;\n  }\n\n  .slide-2-hero {\n    font-size: 2.5rem;\n  }\n  \n/* Slide 3: Key Benefits */\n.slide-3 {\n  height: 60vh; /* Each slide still takes up the full viewport height */\n  padding: 40px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.benefits-container {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  align-items: stretch;\n  flex-wrap: wrap; /* Adjust layout on smaller screens */\n  margin-top: 20px;\n}\n\n.benefit-card {\n  background: #f9f9f9;\n  color: #333;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  width: 300px; /* Set a fixed width for cards */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.benefit-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);\n}\n\n.benefit-icon {\n  width: 60px;\n  height: 60px;\n  margin-bottom: 15px;\n}\n\n.benefit-card h3 {\n  font-size: 1.5rem;\n  margin-bottom: 10px;\n}\n\n.benefit-card p {\n  font-size: 1rem;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .benefits-container {\n    flex-direction: column;\n    align-items: center;\n    gap: 30px;\n    width: 90%;\n  }\n\n  .benefit-card {\n    width: 90%; /* Make cards full width on smaller screens */\n  }\n}\n  \n/* Contact Section */\n.slide-4 {\n  margin-top: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px;\n  text-align: center;\n  height: 40vh; /* Full viewport height */\n}\n\n/* One Unified Contact Box */\n.contact-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  width: 70%; /* Centralized width */\n  max-width: 1200px;\n  background: #ffffff; /* White background for the box */\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  gap: 20px;\n  text-align: left;\n  position: relative;\n  margin-bottom:140px;\n}\n\n/* Left Side: Waitlist */\n.left-side {\n  flex: 1;\n  padding: 20px;\n}\n\n.left-side h2 {\n  margin-top: 0px;\n  margin-bottom: 20px;\n  font-size: 1.8rem;\n  color: #333;\n}\n\n.waitlist-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.waitlist-form .email-input {\n  padding: 10px;\n  font-size: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.waitlist-form .submit-button {\n  padding: 10px 20px;\n  background-color: #20584F;\n  color: white;\n  font-size: 1rem;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.waitlist-form .submit-button:hover {\n  background-color: #2e7b6f;\n}\n\n/* Right Side: Contact Us */\n.right-side {\n  flex: 1;\n  padding: 20px;\n}\n\n.right-side h2 {\n  margin-top: 0px;\n  margin-bottom: 20px;\n  font-size: 1.8rem;\n  color: #333;\n}\n\n.right-side p {\n  margin: 10px 0;\n  font-size: 1rem;\n  color: #555;\n}\n\n.right-side a {\n  color: #20584F;\n  text-decoration: none;\n  font-weight: bold;\n  transition: color 0.3s ease;\n}\n\n.right-side a:hover {\n  color: #2e7b6f;\n}\n\n/* Divider Line */\n.divider {\n  width: 1px;\n  background: #ccc; /* Light grey line */\n  margin: 0 20px;\n  align-self: stretch; /* Ensures it spans the height of the box */\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .contact-box {\n    flex-direction: column;\n    gap: 0;\n    width: 80%;\n  }\n\n  .divider {\n    display: none; /* Remove divider on smaller screens */\n  }\n\n  .left-side,\n  .right-side {\n    padding: 20px 0;\n  }\n}\n\n\n  \n\n  @media (max-width: 768px) {\n    /* General Styles for Phone View */\n    .home-container {\n        scroll-snap-type: none;\n        height: auto; /* Allow container to expand with content */\n        overflow-y: auto;\n    }\n\n    .slide {\n        scroll-snap-align: none; /* Remove snap alignment */\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: center;\n        text-align: center;\n        padding: 20px;\n        height: auto;\n    }\n\n    .navbar {\n        display: none;\n      }\n\n    /* Title Slide (Company Name Only) */\n    .title-slide {\n      height: auto; /* Adjust dynamically based on content */\n      padding: 20px;\n    }\n\n    .title-slide h1 {\n        font-size: 3rem;\n    }\n  \n    .title-left {\n      width: 100%; /* Use full width for the company name */\n      text-align: center; /* Center the company name */\n      padding: 20px 0;\n    }\n\n    .hero-logo {\n        padding-top: 25px;\n    }\n  \n    .title-right {\n      display: none; /* Hide the ocean image */\n    }\n  \n    /* Slide 2: Product Image and Info */\n    .slide-2 {\n      padding: 20px 0;\n    }\n  \n    .slide-2-left {\n      width: 100%; /* Make the product image full-width */\n      text-align: center;\n    }\n  \n    .product-image {\n      width: 80%; /* Scale down the product image */\n      height: auto; /* Maintain aspect ratio */\n      margin-bottom: 20px;\n    }\n  \n    .slide-2-right {\n      width: 90%; /* Use full width for product info */\n      text-align: left; /* Center-align product info */\n      padding: 20px;\n      margin: 20px;\n    }\n  \n    /* Slide 3: Use Case Cards Stacked Vertically */\n    .slide-3 {\n      padding: 20px 0;\n    }\n  \n    .use-case-gallery {\n      flex-direction: column; /* Stack use cases vertically */\n      gap: 20px; /* Add spacing between cards */\n      width: 100%;\n    }\n  \n    .use-case {\n      width: 100%; /* Adjust width for smaller screens */\n      height: 160px;\n      max-width: 300px; /* Limit max size */\n      margin: 0 auto; /* Center each use case card */\n    }\n  \n    .use-case-image {\n      width: 100%; /* Make the image fill the card */\n      height: 160px; /* Maintain consistent height for all images */\n    }\n  \n    .use-case-label {\n      font-size: 1rem; /* Adjust font size for readability */\n      padding: 10px;\n    }\n  \n    /* Slide 4: Form */\n    .slide-4 {\n      padding: 20px 0;\n    }\n  \n    .contact-form {\n        width: 90%; /* Restrict form to one-third of the screen width */\n        max-width: 400px; /* Ensure the form doesn't get too wide on larger screens */\n        background-color: rgba(219, 219, 219, 0.9); /* Semi-transparent white background */\n        padding: 20px;\n        border-radius: 10px;\n        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* Add subtle shadow for depth */\n        display: flex;\n        flex-direction: column;\n        gap: 15px; /* Spacing between form elements */\n      }\n    .contact-form-container {\n      width: 100%; /* Expand form to fill most of the screen */\n      max-width: none; /* Remove width limit */\n      padding: 20px;\n    }\n  \n    .contact-form-container h2 {\n      font-size: 1.5rem; /* Adjust font size for smaller screens */\n    }\n  \n    .email-input,\n    .message-input {\n        font-size: 0.9rem; /* Slightly smaller inputs */\n        width: 100%; /* Ensure inputs match the width of the form */\n        box-sizing: border-box; /* Include padding and borders in width calculation */\n        padding: 10px; /* Add padding for readability */\n        border: 1px solid #ccc;\n        border-radius: 5px;\n    }\n  \n    .submit-button {\n      font-size: 1rem; /* Maintain button size */\n    }\n\n    .scroll-indicator {\n        display: none; /* Completely hide the element */\n    }\n\n  }\n\n  .confirmation-message {\n    margin-top: 10px;\n    font-size: 1rem;\n    color: #41ad9b;\n    text-align: center;\n  }\n  \n\n  .footer {\n    background-color: #000;\n    color: #fff;\n    padding: 20px 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n  \n  .footer-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    width: 100%;\n    max-width: 1200px;\n  }\n  \n  .footer-left {\n    flex: 1;\n    min-width: 250px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .footer-logo {\n    max-width: 150px;\n    margin-bottom: 10px;\n  }\n  \n  .footer-center {\n    flex: 1;\n    min-width: 250px;\n    text-align: center;\n  }\n  \n  .footer-links {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    justify-content: center;\n    gap: 15px;\n  }\n  \n  .footer-links li {\n    margin: 0;\n  }\n  \n  .footer-links a {\n    text-decoration: none;\n    color: #41AD9B;\n    font-weight: bold;\n    transition: color 0.3s;\n  }\n  \n  .footer-links a:hover {\n    color: #fff;\n  }\n  \n  .footer-right {\n    flex: 1;\n    min-width: 250px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n  }\n  \n  .social-icons {\n    display: flex;\n    gap: 15px;\n  }\n  \n  .social-icons a img {\n    width: 24px;\n    height: 24px;\n    filter: invert(100%);\n    transition: filter 0.3s;\n  }\n  \n  .social-icons a img:hover {\n    filter: invert(60%);\n  }\n  \n  /* Responsive Design for Footer */\n  @media (max-width: 768px) {\n    .footer-container {\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n    }\n  \n    .footer-left,\n    .footer-center,\n    .footer-right {\n      align-items: center;\n      margin-bottom: 20px;\n    }\n  \n    .footer-right {\n      align-items: center;\n    }\n\n    \n  }\n  \n/* Video Section Styles */\n.video-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 60px 20px;\n  background: transparent;\n}\n\n.video-container {\n  width: 50%;\n  max-width: 800px;\n  position: relative;\n  padding-bottom: 28.125%; /* Maintains 16:9 aspect ratio (50% * 9/16) */\n}\n\n.video-container iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n/* Responsive design for video */\n@media (max-width: 768px) {\n  .video-container {\n    width: 90%;\n    padding-bottom: 50.625%; /* Maintains 16:9 aspect ratio (90% * 9/16) */\n  }\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
